import { Space, Tag, Typography } from 'antd';
import JumpLink from 'components/JumpLink';
import SuccessDocumentIcon from 'components/SuccessDocument';
import BaseTable from 'components/Table';
import { getStatusTagColor } from 'containers/CustomerCenter/Companies/utils';
import dayjs from 'dayjs';
import React from 'react';
import { useNavigate } from 'react-router';
import { formatPhoneNumber, priceTransformer } from 'utils';
import { generateColumns } from 'utils/table';

const renderStatus = (status) => (
  <Tag color={getStatusTagColor(status)}>
    {status}
  </Tag>
);

const columns = generateColumns([
  {
    title: 'Name',
    key: 'name',
    width: 200,
    columnKey: 'name',
    render: (_, { id, first_name, last_name }) => (
      <JumpLink href={`/console/contacts/${id}`} text={`${first_name} ${last_name}`} />
    ),
  },
  {
    title: 'STATUS',
    key: 'status',
    width: 80,
    render: renderStatus,
  },
  {
    title: 'Company',
    width: 120,
    key: 'company',
    render: (_, { company }) => (
      <JumpLink href={`/console/companies/${company?.id}/info`} text={company?.name} />
    ),
  },
  {
    title: 'Email',
    width: 150,
    key: 'email',
  },
  {
    title: 'Phone number',
    key: 'phone',
    width: 150,
    render: formatPhoneNumber,
  },
  {
    title: 'Origin',
    key: 'source',
    width: 100,
    ellipsis: false,
  },
  {
    title: 'Last order',
    key: 'last_order_date',
    width: 120,
    render: (d) => (d ? dayjs(d)?.format('MMM D') : ' - '),
  },
  {
    title: 'Orders',
    key: 'orders_count',
    width: 80,
  },
  {
    title: 'Order Frequency',
    key: 'order_frequency',
    width: 80,
  },
  {
    title: 'Spent',
    key: 'total_spent',
    width: 100,
    render: (value) => priceTransformer(value?.toFixed(2)),
  },
]);

function Table({ fetchCustomers, ...props }) {
  const navigate = useNavigate();

  return (
    <BaseTable
      id="contacts"
      columns={columns}
      fetchFn={fetchCustomers}
      pagination={{ pageSize: 50 }}
      empty={(
        <Space direction="vertical" className="my-10 mx-5">
          <SuccessDocumentIcon />
          <Typography.Paragraph>
            It looks like our contacts list is as empty as a dining room at closing
            time!
          </Typography.Paragraph>
        </Space>
      )}
      onRow={(record) => ({
        onClick: (event) => {
          if (event.isLink) {
            return;
          }
          // Check if click is on selection cell (handled by custom renderCell now)
          const { target } = event;
          const isSelectionCell = target.classList.contains('ant-table-selection-column');

          if (isSelectionCell) {
            // Selection is handled by the custom renderCell function
            return;
          }

          navigate(`/console/contacts/${record?.id}`);
        },
      })}
      scroll={{ x: 400 }}
      {...props}
    />
  );
}

export default Table;
